import { selectStencil, unselectStencil } from "../services/stencilWeekService";

/**
 * This toggles the category selected to either be included or excluded from the
 * list of categories to filter by
 * @param {Object} category category being added or removed from filtering list
 * @param {Array} selectedCategories array of categories selected for filtering
 * @param {Function} setSelectedCategories setter for selectedCategories array
 */
export function toggleCategory(
  category,
  selectedCategories,
  setSelectedCategories
) {
  if (selectedCategories.includes(category)) {
    let newCats = selectedCategories.filter((cat) => cat !== category);
    setSelectedCategories(newCats);
  } else setSelectedCategories([...selectedCategories, category]);
}

/**
 * This filters stencils by categories and weeks selected, going into some checking
 * to ensure that the stencils being filtered also match the search criteria.
 * @param {Array} filteredSelection array of stencils that match the criteria from
 *                              the search
 * @param {String} weeks String representation of the weeks to filter by
 * @param {Array} selectedCategories array of categories to filter by
 * @param {Function} setKeywords setter for keywords array
 * @param {Boolean} showArchived boolean value to determine if 
 */
export function stencilFilter(
  shownSelection,
  filteredSelection,
  weeks,
  selectedCategories,
  setKeywords,
  searching
) {
  let weekStencils = [];
  let finalList = [];
  let list = [];

  // only include the stencils that match the search criteria AND are shown:
  if (filteredSelection?.length === 0 && !searching)
    list = shownSelection;
  else
    list = shownSelection.filter((s) => filteredSelection.includes(s));

  // week filtering
  if (weeks === "none" || weeks === "all") weekStencils = list;
  else {
    // loop through and add stencils for each selected week
    for (var stencil of list) {
      if (stencil[weeks] === 1) weekStencils.push(stencil);
    }
  }

  // category filtering
  if (selectedCategories.length === 0) finalList = weekStencils;
  else {
    // loop through and add stencils based on selected selectedCategories
    for (var s of weekStencils) {
      for (var cat of selectedCategories) {
        if (Number(s.category_id) === cat) finalList.push(s);
      }
    }
  }
  setKeywords(finalList);
}

/**
 * Checks or unchecks a stencil for a given week
 * @param {Object} stencil Stencil to check or uncheck
 * @param {int} index int representing what week to check or uncheck for
 *                  the given stencil
 * @param {Function} setSelectedStencil setter for selectedStencil to display
 * @param {Object} selectedStencil stencil selected to be displayed in the right
 *                              sidebar
 * @param {Function} setKeywords setter for keywords array
 */
export async function handleCheck(
  stencil,
  index,
  setSelectedStencil,
  selectedStencil,
  setKeywords,
  stencils,
  setStencils,
  stencilWeeks,
  setStencilWeeks
) {
  // copy to revert to in case of failure:
  const originalStencils = stencils;

  // Build correct request
  const string = `isSelectedWeek${index}`;
  const promise =
    Number(stencil[string]) === 0
      ? selectStencil(index, stencil.id)
      : unselectStencil(index, stencil.id);

  // Based on response, update stencils and keywords
  const newStencil = {
    ...stencil,
    [string]: Number(stencil[string]) === 0 ? 1 : 0,
  };
  const newStencils = stencils.map((el) => {
    if (el.id === stencil.id) {
      if (selectedStencil && selectedStencil.id === stencil.id)
        setSelectedStencil(newStencil);
      return newStencil;
    } else return el;
  });

  setStencils(newStencils);
  setKeywords(newStencils);

  // When the stencil week has been created or destroyed...
  promise.then(async (response) => {
    // Revert on failure
    if (!response.ok) {
      setStencils(originalStencils);
      setKeywords(originalStencils);
      alert(`Error selecting/unselecting stencil ${stencil.id}`);
    }

    // Otherwise update stencil week store
    else {
      // Update stencilWeeks store based on selected or unselected stencil
      if (stencil[string] === 0) {
        const json = await response.json();
        setStencilWeeks([...stencilWeeks, json.data]);
      } else {
        const trimmed = stencilWeeks.filter(
          (sw) => sw.week_num !== index && sw.stencil_id === stencil.id
        );
        setStencilWeeks(trimmed);
      }
    }
  });
}
